
import { Component } from "vue-property-decorator";
import { HcPageModel } from "@dev/hc-components";
import { MainLayout } from "@/app/index";

@Component({
    components: { MainLayout }
})
export default class ExternalSite extends HcPageModel {

    protected pageName: string = "external-site";
    public name: string = "external-site";

    private get url (): string {
        return this.$route.params.url;
    }
}
